export default class JWTParser {
    constructor(token) {
        this.jose = null;
        this.payload = null;
        this.signature = null;

        this.parse(token);
    }

    parse(token) {
        if (!token) {
            return;
        }

        let [jose, payload, signature] = token.split('.');
        this.jose = JSON.parse(atob(jose));
        this.payload = JSON.parse(atob(payload));
        this.signature = signature;
    }

    get valid() {
        let now = Math.floor(Date.now() / 1000);
        return this.payload.exp >= now;
    }
}
